import React, { CSSProperties, PropsWithChildren } from "react";
import classes from "./PdfLayout.module.less";

interface PdfLayoutProps {
    style?: CSSProperties;
    title?: string;
    company?: string;
    page?: number;
}

export const PdfLayout: React.FC<PropsWithChildren<PdfLayoutProps>> = ({
    children,
    style,
    title,
    company,
    page,
}) => {
    const titleElement = title ? <div className={classes.title}>{title}</div> : null;
    const companyElement = company ? (
        <div className={classes.watermark}>PREPARED FOR {company}</div>
    ) : null;

    return (
        <div className={classes.container} style={style}>
            <div className={classes.header}>
                <img
                    src="/infinity-loop-logo-horz-color-wt.svg"
                    alt="logo"
                    className={classes.logo}
                />
                {titleElement}
            </div>
            <div className={classes.content}>{children}</div>
            {companyElement}
            <div className={classes.footer}>
                <span>© Infinity Loop {new Date().getFullYear()}</span>
                <span className={classes.page}>{page}</span>
                <span>Confidential</span>
            </div>
        </div>
    );
};
